import React from "react";
import Marquee from "react-fast-marquee";
import logo from "../assets/Images/new_logo.jpg";
import { Config } from "../Config";

const Footer = ({ contactSection }) => {
  return (
    <>
      <section className="py-2 bg-light">
        <div className="container-box pt-md-4">
          {/* Marquee Section */}
          {contactSection.longitude && (
            <div className="py-2 mt-4">
              <Marquee
                className="text-danger fw-bold"
                style={{
                  letterSpacing: "1.5px",
                  width: "100vw",
                  marginLeft: "calc(-50vw + 50%)",
                  marginBottom: "30px",
                  backgroundColor: "#bcdbf5ff",
                  padding: "8px",
                }}
              >
                {contactSection.longitude}
              </Marquee>
            </div>
          )}

          <div className="row mt-4 gy-4">
            {/* Contact Info */}
            <div className="col-lg-4 col-md-6 d-flex flex-column">
              {/* Logo */}
              <div className="d-flex align-items-center mb-3">
                <img
                  src={logo}
                  alt="Haryana Affordable Housing Shop Logo"
                  className="footer-logo"
                  style={{
                    height: "70px",
                    width: "auto",
                  }}
                />
              </div>

              <ul className="list-unstyled">
                {contactSection.contact_numbers && (
                  <li className="mb-2">
                    <i className="bi bi-telephone-fill me-2 footer-icon"></i>
                    <a
                      href={`tel:${contactSection.contact_numbers}`}
                      className="text-dark text-decoration-none hover-link"
                    >
                      {contactSection.contact_numbers}
                    </a>
                  </li>
                )}

                {contactSection.contact_mails && (
                  <li className="mb-2">
                    <i className="bi bi-envelope-fill me-2 footer-icon"></i>
                    <a
                      href={`mailto:${contactSection.contact_mails}`}
                      className="text-dark text-decoration-none email-small hover-link"
                    >
                      {contactSection.contact_mails}
                    </a>
                  </li>
                )}

                {contactSection.contact_addresses && (
                  <li className="mb-2">
                    <i className="bi bi-geo-alt-fill me-2 footer-icon"></i>
                    <span className="text-muted">
                      {contactSection.contact_addresses}
                    </span>
                  </li>
                )}
              </ul>

              {/* Social Links */}
              <div className="d-flex gap-3 mt-3">
                <a href="#" className="social-icon">
                  <i className="bi bi-facebook footer-icon"></i>
                </a>
                <a href="#" className="social-icon">
                  <i className="bi bi-instagram footer-icon"></i>
                </a>
                <a href="#" className="social-icon">
                  <i className="bi bi-twitter-x footer-icon"></i>
                </a>
                <a href="#" className="social-icon">
                  <i className="bi bi-linkedin footer-icon"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3 text-dark">Quick Links</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}affordable/policy`}
                    className="footer-link quick-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Affordable Policy
                  </a>
                </li>

                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}refund-policy`}
                    className="footer-link quick-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Refund Policy
                  </a>
                </li>

                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}terms-conditions`}
                    className="footer-link quick-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Terms and Conditions
                  </a>
                </li>

                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}privacy-policy`}
                    className="footer-link quick-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            {/* Projects */}
            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3 text-dark">Projects</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}all-projects`}
                    className="footer-link project-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Ongoing Projects
                  </a>
                </li>

                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}all-projects`}
                    className="footer-link project-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Upcoming Projects
                  </a>
                </li>

                <li className="mb-2">
                  <a
                    href={`${Config.appUrl}all-projects`}
                    className="footer-link project-link"
                  >
                    <i className="bi bi-chevron-right me-1 footer-icon"></i>
                    Closed Projects
                  </a>
                </li>
              </ul>
            </div>

            {/* Get in Touch */}
            <div className="col-lg-4 col-md-6">
              <h6 className="fw-bold mb-3 text-dark">Get in Touch</h6>
              <p className="mb-3 text-muted">
                Reach out to us via our{" "}
                <a
                  href={`${Config.appUrl}get-in-touch`}
                  className="text-decoration-none fw-medium hover-link"
                  style={{ color: "#135a94" }}
                >
                  contact form
                </a>
                . We respond within 24 hours.
              </p>

              <p className="mb-2">
                <i className="bi bi-telephone-fill me-2 footer-icon"></i>
                <a
                  href={`tel:${contactSection.contact_numbers}`}
                  className="text-dark text-decoration-none fw-medium hover-link"
                >
                  {contactSection.contact_numbers}
                </a>
              </p>

              <p className="mb-0">
                <i className="bi bi-envelope-fill me-2 footer-icon"></i>
                <a
                  href={`mailto:${contactSection.contact_mails}`}
                  className="text-dark text-decoration-none email-small hover-link"
                >
                  {contactSection.contact_mails}
                </a>
              </p>
            </div>
          </div>

          <hr className="my-4" />

          {/* Footer Bottom Navigation Links */}
          <div className="text-center mb-4 footer-bottom-links">
            <a
              href={`${Config.appUrl}affordable/policy`}
              className="footer-link quick-link mx-2"
            >
              Affordable Policy
            </a>
            <span className="text-muted">|</span>

            <a
              href={`${Config.appUrl}refund-policy`}
              className="footer-link quick-link mx-2"
            >
              Refund Policy
            </a>
            <span className="text-muted">|</span>

            <a
              href={`${Config.appUrl}terms-conditions`}
              className="footer-link quick-link mx-2"
            >
              Terms and Conditions
            </a>
            <span className="text-muted">|</span>

            <a
              href={`${Config.appUrl}privacy-policy`}
              className="footer-link quick-link mx-2"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </section>

      {/* Bottom Footer */}
      <footer style={{ backgroundColor: "#155995" }}>
        <div className="container-box py-3 text-white text-center">
          <p className="mb-0">
            © {new Date().getFullYear()} haryanaaffordablehousingshop.com |
            Powered By haryanaaffordablehousingshop.com | All Rights Reserved
          </p>
        </div>
      </footer>

      {/* CSS */}
      <style>
        {`
          .footer-logo {
            display: block;
            object-fit: contain;
          }

          .email-small {
            font-size: 16px;
            word-break: break-word;
            max-width: 100%;
            display: inline-block;
          }
          @media (max-width: 767px) {
            .email-small { font-size: 0.75rem; }
          }

          /* Global Icon Color */
          .footer-icon,
          .social-icon i {
            color: #135a94 !important;
            fill: #135a94 !important;
          }

          /* Apply #135a94 Colors */
          .quick-link,
          .project-link,
          .footer-bottom-links a {
            color: #135a94 !important;
            font-weight: 500;
          }

          /* Global Hover Underline */
          .hover-link,
          .footer-link,
          .quick-link,
          .project-link,
          .footer-bottom-links a {
            position: relative;
            text-decoration: none;
          }

          .hover-link::after,
          .footer-link::after,
          .quick-link::after,
          .project-link::after,
          .footer-bottom-links a::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -1px;
            width: 0%;
            height: 1px;
            background-color: currentColor;
            transition: width 0.3s ease;
          }

          .hover-link:hover::after,
          .footer-link:hover::after,
          .quick-link:hover::after,
          .project-link:hover::after,
          .footer-bottom-links a:hover::after {
            width: 100%;
          }

          .hover-link:hover { color: #135a94 !important; }

          /* Social Icons */
          .social-icon {
            font-size: 1.25rem;
            transition: all 0.3s ease;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 50%;
          }
          .social-icon:hover {
            transform: translateY(-3px);
            background-color: rgba(19, 90, 148, 0.1);
          }

          /* Contact Box */
          .contact-box {
            border-left: 3px solid #155995;
            transition: box-shadow 0.3s ease;
          }
          .contact-box:hover {
            box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
          }
        `}
      </style>
    </>
  );
};

export default Footer;
